export const DASHBOARD_SPORTS = [
  "NBA",
  "NHL",
  "NFL",
  "MLB",
  "SOCCER",
  "NBL",
] as const;
export type DashboardSport = (typeof DASHBOARD_SPORTS)[number];

export function SportSelector({
  sport,
  onChange,
  disabled = false,
  includeAll = false,
}: {
  sport: DashboardSport | "ALL";
  onChange: (sport: DashboardSport | "ALL") => void;
  disabled?: boolean;
  /** Offer a combined board. Off by default: pages that can only render one
   * sport must not be handed "ALL". */
  includeAll?: boolean;
}) {
  return (
    <div className="sport-selector" role="group" aria-label="Sport filter">
      {(includeAll
        ? (["ALL", ...DASHBOARD_SPORTS] as const)
        : DASHBOARD_SPORTS
      ).map((item) => (
        <button
          key={item}
          type="button"
          aria-pressed={sport === item}
          disabled={disabled}
          onClick={() => onChange(item)}
        >
          {item === "ALL" ? "All" : item}
        </button>
      ))}
    </div>
  );
}
